export const PILOT_PICKUP_ORDER_LIMIT_REACHED =
  'PILOT_PICKUP_ORDER_LIMIT_REACHED';

export function getPickupOrderCreateErrorTranslationKey(
  code: string | null | undefined,
): string | null {
  return code === PILOT_PICKUP_ORDER_LIMIT_REACHED
    ? 'pickupOrders.create.pilotLimitReached'
    : null;
}
